export default {
    login:{
        account:'Account',
        password:'Password',
        login:'Login',
        reste:'Reset',
        inputAccount:"Please enter a username!",
        inputPassword:'Please enter your password!',
        lengthInvalid:'The password is between 8-16 characters long!',
        loginFaild:'Login failed'
    },
    startPage:{
        title:'Vue Study'
    },
    menu:{
        home:'Home',
        Management:'Management',
        Personnel:'Personnel',
        Menu1:'Menu',
        HelloWorld:'HelloWorld'
    },
    userMenu:{
        Setting:'Setting',
        Exit:'Exit'
    },
    options:{
        Title:'Setting',
        Language:'Language'
    }
}